module.exports = __webpack_public_path__ + "fonts/Nimbus-Sans-D-OT-Regular-Extended_32755.3adda59.ttf";